/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ReturnOrderStatus = "AUTHORIZED" | "CLOSED" | "RECEIVED" | "REJECTED" | "REQUESTED";
export type ReturnReason = "CUSTOMER_CHANGED_MIND" | "DAMAGED" | "DEFECTIVE" | "NOT_AS_DESCRIBED" | "OTHER" | "WRONG_ITEM";
export type ReturnType = "CREDIT" | "REFUND" | "REPAIR" | "REPLACEMENT";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReturnsTable_returnOrderEdges$ref: FragmentReference;
declare export opaque type ReturnsTable_returnOrderEdges$fragmentType: ReturnsTable_returnOrderEdges$ref;
export type ReturnsTable_returnOrderEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +returnNumber: string,
    +status: ReturnOrderStatus,
    +returnType: ?ReturnType,
    +reason: ?ReturnReason,
    +order: ?{|
      +id: string,
      +orderNumber: string,
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +createdAt: any,
    +updatedAt: any,
  |},
  +$refType: ReturnsTable_returnOrderEdges$ref,
|}>;
export type ReturnsTable_returnOrderEdges$data = ReturnsTable_returnOrderEdges;
export type ReturnsTable_returnOrderEdges$key = {
  +$data?: ReturnsTable_returnOrderEdges$data,
  +$fragmentRefs: ReturnsTable_returnOrderEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ReturnsTable_returnOrderEdges",
  "type": "ReturnOrderEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "ReturnOrder",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "returnNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "returnType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "reason",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "orderNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customer",
          "storageKey": null,
          "args": null,
          "concreteType": "Customer",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "updatedAt",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '0c19c86c4a9e3029b0163308449919ba';
module.exports = node;
